// Generado desde design-system/brand/DbLogo.tsx — no editar; edita el .ts/.tsx y corre build-ds.
import { ISO_PATHS, ISO_VIEWBOX, LOGO_VIEWBOX, WORDMARK_PATHS } from './logo-paths';
/** Línea bajo DATA BUNKER en el lockup completo (unidades del viewBox del manual). */
const RULE_GAP = 4;
const RULE_H = 2.2;
const TONES = {
    color: { blue: 'var(--db-brand-blue)', navy: 'var(--db-brand-navy)', word: 'var(--db-brand-navy)' },
    // Negativo (manual: "Alternativa en negativo"): todo en un solo tono claro
    mono: { blue: 'currentColor', navy: 'currentColor', word: 'currentColor' },
};
/**
 * Logo oficial de Data Bunker (vectores del manual de marca), SIN slogan: Data Bunker pidió quitar el
 * slogan del manual en todos los lockups (revisión 2026-10-13). No hay prop para volver a pintarlo.
 * variant: "color" (fondos claros) | "mono" (usa currentColor; fondos oscuros o imagen)
 * lockup:  "full" (isotipo + DATA BUNKER + línea fina, como el logo animado) | "iso" (solo isotipo)
 *          | "horizontal" (isotipo + DATA BUNKER en una línea)
 * Reglas del manual: ancho mínimo 20 mm (≈ 76 px); área de protección = alto del isotipo;
 * no deformar, no recolorear fuera de las variantes, no añadir efectos.
 */
export function DbLogo({ variant = 'color', lockup = 'full', className, title = 'Data Bunker', ...rest }) {
    const t = TONES[variant] ?? TONES.color;
    const iso = ISO_PATHS.map((p, i) => <path key={i} d={p.d} fill={t[p.tone]}/>);
    const word = WORDMARK_PATHS.map((d, i) => <path key={i} d={d} fill={t.word}/>);
    if (lockup === 'iso') {
        return (<svg viewBox={ISO_VIEWBOX.join(' ')} role="img" aria-label={title} className={className} {...rest}>
        {iso}
      </svg>);
    }
    if (lockup === 'horizontal') {
        const [ix, , iw, ih] = ISO_VIEWBOX;
        const wordTop = 158.55;
        const wordH = LOGO_VIEWBOX[3] - wordTop;
        const scale = (ih * 0.42) / wordH;
        return (<svg viewBox={`${ix} 0 ${iw + 24 + LOGO_VIEWBOX[2] * scale} ${ih}`} role="img" aria-label={title} className={className} {...rest}>
        <g>{iso}</g>
        <g transform={`translate(${ix + iw + 24} ${ih * 0.29}) scale(${scale}) translate(0 ${-wordTop})`}>{word}</g>
      </svg>);
    }
    // Completo: la línea fina bajo DATA BUNKER se queda (igual que el logo animado); el viewBox termina en ella.
    const [, , w, h] = LOGO_VIEWBOX;
    return (<svg viewBox={`0 0 ${w} ${h + RULE_GAP + RULE_H}`} role="img" aria-label={title} className={className} {...rest}>
      {iso}
      {word}
      <rect x="0" y={h + RULE_GAP} width={w} height={RULE_H} fill={t.word}/>
    </svg>);
}
